import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HubTaskbar from '../HubTaskbar';
import '../../../assets/css/Hub.css';
import axios from 'axios';

type MACSidebarProps = {
  collapsed?: boolean;
  onCollapseToggle?: (collapsed: boolean) => void;
};

export default function MACSidebar(props: MACSidebarProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { collapsed: collapsedProp, onCollapseToggle } = props || {};
  const [collapsed, setCollapsed] = useState<boolean>(!!collapsedProp);

  useEffect(() => {
    if (typeof collapsedProp === 'boolean') {
      setCollapsed(collapsedProp);
    }
  }, [collapsedProp]);

  const toggleCollapsed = () => {
    const next = !collapsed;
    setCollapsed(next);
    if (onCollapseToggle) onCollapseToggle(next);
  };

  const macSections = [
    { id: 'dashboard', label: 'Dashboard', icon: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z' },
    { id: 'conversation-history', label: 'Conversation History', icon: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' },
    { id: 'unreads', label: 'Unreads', icon: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z M22 6l-10 7L2 6' },
    { id: 'channels', label: 'Channels', icon: 'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' },
    { id: 'direct-messages', label: 'Direct Messages', icon: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M23 21v-2a4 4 0 0 0-3-3.87 M16 3.13a4 4 0 0 1 0 7.75' },
    { id: 'mac', label: 'Launch MAC', icon: 'M2.5 14.5 L7.5 10.5 V22 L2.5 26 Z M9.5 9 L14.5 5 V22 L9.5 26 Z M16.5 3 L21.5 0 V20 L16.5 24 Z' },
  ];

  const onMacToolsClicked = (sectionId: string) => {
    if (sectionId == 'mac') {

      let config = {
        method: 'get',
        url: 'https://test-null-ref-express.nowcerts.com/api/Fusion/GetFusionToken',
        headers: {
          Authorization: `Bearer ${localStorage.getItem("amsToken")}`,
        }
      };

      axios.request(config)
        .then((response: any) => {
          window.open("https://staging.fusionnowcrm.com/now-certs-auth?token=" + response.data.token, "_blank");
        })
        .catch((error: any) => {
          if (error.response?.status === 401) {
            localStorage.clear();
            navigate("/");
          }
          else {
          }
        });
    }
  }
  return (
    <aside className={`amp-sidebar-theme${collapsed ? ' collapsed' : ''}`}>
      <div className="amp-sidebar-layout">
        <HubTaskbar compact={false} collapsed={collapsed} onToggleCollapse={toggleCollapsed} />
        <div className={`amp-sidebar-main${collapsed ? ' collapsed' : ''}`}>
          <div className="amp-sidebar-inner">

            <div className="mac-sidebar-section-title">
              <h3>
                MAC Tools
              </h3>
            </div>

            <nav className="amp-sidebar-history-section mac-sidebar-nav">
              <ul className="amp-sidebar-history-list">
                {macSections.map(section => (
                  <li key={section.id}>
                    <button
                      className="mac-sidebar-item"
                      onClick={() => { onMacToolsClicked(section.id); }}
                      title={section.label}
                    >
                      <span className="mac-sidebar-item-icon">
                        <svg viewBox="0 0 24 24">
                          <path d={section.icon} />
                        </svg>
                      </span>
                      <span className="mac-sidebar-item-text">
                        {section.label}
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="mac-sidebar-footer">
              <div className="mac-sidebar-info-card">
                <p className="mac-sidebar-info-text">
                  Manage and configure your MAC system
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
